import { useState, useRef, useEffect } from "react";

export default function ColumnNavigator({ columns, onNavigate }) {
  const [searchTerm, setSearchTerm] = useState("");
  const [showDropdown, setShowDropdown] = useState(false);
  const [filteredColumns, setFilteredColumns] = useState([]);
  const wrapperRef = useRef(null);

  useEffect(() => {
    if (searchTerm.trim()) {
      const filtered = columns
        .map((col, index) => ({ ...col, index }))
        .filter((col) =>
          col.text.toLowerCase().includes(searchTerm.toLowerCase())
        );
      setFilteredColumns(filtered);
      setShowDropdown(true);
    } else {
      setFilteredColumns([]);
      setShowDropdown(false);
    }
  }, [searchTerm, columns]);

  useEffect(() => {
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleSelectColumn = (index) => {
    onNavigate(index);
    setSearchTerm("");
    setShowDropdown(false);
  };

  return (
    <div className="inline-block" ref={wrapperRef}>
      <div className="relative">
        <div className="flex items-center gap-2 bg-gradient-to-r from-blue-600 to-blue-700 px-4 py-2 rounded-lg shadow-md">
          <svg 
            className="w-5 h-5 text-white" 
            fill="none" 
            stroke="currentColor" 
            viewBox="0 0 24 24"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
          </svg>
          <input
            type="text"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            onFocus={() => searchTerm && setShowDropdown(true)}
            placeholder="Jump to column..."
            className="bg-white px-3 py-1.5 rounded-md border-0 focus:ring-2 focus:ring-blue-300 outline-none text-gray-800 placeholder-gray-400 w-64"
          />
        </div>
        {showDropdown && filteredColumns.length > 0 && (
          <div className="absolute z-10 w-full mt-2 bg-white border border-gray-200 rounded-lg shadow-xl max-h-72 overflow-y-auto">
            {filteredColumns.map((col) => (
              <div
                key={col.index}
                onClick={() => handleSelectColumn(col.index)}
                className="p-3 hover:bg-blue-50 cursor-pointer border-b border-gray-100 last:border-b-0 transition-all hover:pl-4"
              >
                <span className="text-gray-700 text-sm">{col.text}</span>
              </div>
            ))}
          </div>
        )}
        {showDropdown && searchTerm && filteredColumns.length === 0 && (
          <div className="absolute z-10 w-full mt-2 bg-white border border-gray-200 rounded-lg shadow-xl p-4">
            <span className="text-gray-400 text-sm">No columns found</span>
          </div>
        )}
      </div>
    </div>
  );
}
